<form autocomplete="off" #form="ngForm" *ngIf="prestation">
    <mat-card>
        <mat-card-title>
            <span>{{'admin.frais.prestations.detail.filtres.generiques.title' | translate}}</span>
        </mat-card-title>
        <mat-card-content>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="pays"
                                  name="pays"
                                  [(ngModel)]="prestation.idPays"
                                  [selectOptions]="listePays"
                                  customType="select"
                                  optionDisplay="libelle"
                                  optionValue="idPays"
                                  libelle="admin.frais.prestations.detail.filtres.generiques.pays.title">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="puissanceFiscale"
                                  name="puissanceFiscale"
                                  [(ngModel)]="prestation.idPuissance"
                                  [selectOptions]="listePuissanceFiscale"
                                  customType="select"
                                  optionDisplay="libelle"
                                  optionValue="idPuissance"
                                  libelle="admin.frais.prestations.detail.filtres.generiques.puissanceFiscale"
                                  [disabled]="!listePuissanceFiscale?.length || (prestation?.unite?.typeDistance != TypeDistance.TYPE_DISTANCE_KM && prestation?.unite?.typeDistance != TypeDistance.TYPE_DISTANCE_MILES)">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="familleCharge"
                                  name="familleCharge"
                                  [(ngModel)]="selectedFamilleCharge"
                                  [selectOptions]="listeFamilleCharge"
                                  [valeurIdTampon]="'objetTampon'"
                                  customType="objectselect"
                                  optionDisplay="libelle"
                                  optionValue="code"
                                  [isSelectAvecVide]="false"
                                  [isSelectAvecInput]="false"
                                  libelle="admin.frais.prestations.detail.filtres.generiques.familleCharge.title"
                                  (onChange)="onFamilleChargeChange()">
                    </custom-input>
                </div>
            </fieldset>
        </mat-card-content>
    </mat-card>
</form>
<list-view *ngIf="listeVisibilite" [liste]="listeVisibilite"></list-view>
<list-view *ngIf="listeImport" [liste]="listeImport"></list-view>
<list-view *ngIf="listeMobile" [liste]="listeMobile"></list-view>